define({
    'root': {
        'star0': 'Unrated',
        'star1': '1 star',
        'star2': '2 stars',
        'star3': '3 stars',
        'star4': '4 stars',
        'star5': '5 stars',
        'rating': 'rating'
    }
});
